<template>
  <BaseDataIterator :service="fetchData" disable-search>
    <template #default="dataIteratorProps">
      <BaseDataTable :data="dataIteratorProps.data">
        <template #header>
          <TrackingLogListHeader />
        </template>

        <template #default="dataTableProps">
          <TrackingLogListItem :tracking-log="dataTableProps.item" />
        </template>
      </BaseDataTable>
    </template>
  </BaseDataIterator>
</template>

<script>
import { smsCampaignTrackingLogsClient } from '@/api/clients';
import TrackingLogListHeader from './TrackingLogListHeader.vue';
import TrackingLogListItem from './TrackingLogListItem.vue';

export default {
  components: {
    TrackingLogListHeader,
    TrackingLogListItem,
  },
  props: {
    smsCampaignId: {
      type: String,
      required: true,
    },
  },
  methods: {
    fetchData(params = {}) {
      return smsCampaignTrackingLogsClient.list(this.smsCampaignId, {
        ...params,
        include: 'contacts',
      });
    },
  },
};
</script>
